"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'RegionStorePane',
  components: {},
  props: {
    regionStore: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    echoStoreIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      checkAll: false,
      checkedStoreIds: [],
      isIndeterminate: true
    };
  },
  created: function created() {
    var _this = this;
    if (this.echoStoreIds) {
      // this.echoStoreIds 数组 包含 this.regionStore.storeList
      this.checkedStoreIds = this.echoStoreIds.filter(function (item) {
        return _this.regionStore.storeList.map(function (store) {
          return store.storeId;
        }).includes(item);
      });
    }
  },
  methods: {
    getCheckedStoreIds: function getCheckedStoreIds() {
      return this.checkedStoreIds || [];
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedStoreIds = val ? this.regionStore.storeList.map(function (item) {
        return item.storeId;
      }) : [];
      this.isIndeterminate = false;
      this.$emit('change', this.checkedStoreIds);
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.regionStore.storeList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.regionStore.storeList.length;
      this.$emit('change', value);
    }
  }
};